import { useCallback, useEffect, useRef } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createContainer,
	createSubscriber,
	createActionsHook,
	createHook,
} from '@atlassian/react-sweet-state';
import { actions } from './actions/index.tsx';
import type { State } from './utils.tsx';

type Actions = typeof actions;

type DocumentTitleContainerProps = {
	titleSuffix: string | null;
};

const initialState: State = {
	title: '',
	defaultTitle: '',
	contextArray: [],
};

const Store = createStore<State, Actions>({
	name: 'document-title',
	initialState,
	actions,
});

export const useDocumentTitleActions = createActionsHook(Store);
export const useDocumentTitle = createHook(Store);

export const DocumentTitleContainer = createContainer<State, Actions, DocumentTitleContainerProps>(
	Store,
	{
		displayName: 'DocumentTitleContainer',
	},
);

export const DocumentTitleSubscriber = createSubscriber<
	State,
	Actions,
	undefined,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
>(Store, {
	displayName: 'DocumentTitleSubscriber',
});

export const DocumentTitleHelper: React.FC<{ title: string }> = ({ title }) => {
	const { addDocumentTitle, removeDocumentTitle, updateTitle } = useDocumentTitleActions();
	const identifierRef = useRef(Symbol(title));

	const onUpdate = useCallback(() => {
		updateTitle(title, identifierRef.current);
	}, [updateTitle, title]);

	useEffect(() => {
		const titleRef = identifierRef.current;
		addDocumentTitle(titleRef, title);

		return () => {
			removeDocumentTitle(titleRef);
			onUpdate();
		};
	}, [addDocumentTitle, onUpdate, removeDocumentTitle, title]);

	useEffect(() => {
		onUpdate();
	}, [onUpdate]);

	return null;
};
